import { Divider, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { useAllCodes } from '../api/index.js';
import CategoriesTable from '../components/Categories/CategoriesTable.js';
import { CodesTable, CodeMetadataTable } from '../components/Codes/index.js';
import { type Code } from '../models/index.js';

const Codes = () => {
  const { data = [], isLoading, refetch } = useAllCodes({ includeCategory: true, includeMetadata: true });

  const [selectedRow, setSelectedRow] = useState<Code>();

  useEffect(() => {
    if (selectedRow) {
      setSelectedRow(data.find((item) => item.id === selectedRow.id));
    }
  }, [data]);
  return (
    <>
      <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
        <CodesTable
          data={data}
          isLoading={isLoading}
          refetch={refetch}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
        />
        {selectedRow ? <CodeMetadataTable refetch={refetch} selectedCode={selectedRow} /> : null}
      </Stack>
      <Divider sx={{ m: 2 }} />
      <CategoriesTable />
    </>
  );
};

export default Codes;
